import * as React from "react";
import styled, { css } from "styled-components";
import { Card as MantineCard } from "@mantine/core";
const Container = styled(MantineCard)(
  ({ theme }) => css`
    background-color: ${theme.colors.cards.background};
    border-color: ${theme.colors.cards.border};

    &:focus {
      outline: 5px auto Highlight;
      outline: 5px auto -webkit-focus-ring-color;
    }
  `
);
const Card = ({
  children = void 0,
  className = void 0,
  padding = void 0,
  id = void 0,
  tabIndex = void 0
}) => /* @__PURE__ */ React.createElement(Container, { className, shadow: "sm", padding, radius: "md", withBorder: true, tabIndex, id }, children);
export default Card;
